/* Copyright (C) 2018 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
import * as React from 'react';
import { Alert } from 'react-bootstrap';
// 2. Store and Types. 
// 3. Scripts. 
// 4. Components and Views. 
interface IErrorComponentProps
{
	error?: any;
}

class ErrorComponent extends React.Component<IErrorComponentProps>
{
	constructor(props: IErrorComponentProps)
	{
		super(props);
	}

	public render()
	{
		const { error } = this.props;
		if ( error != undefined && error != null )
		{
			//console.error((new Date()).toISOString() + ' ' + this.constructor.name + '.render', error);
			if (error)
			{
				let sError = error;
				if ( error.message !== undefined )
				{
					sError = error.message;
				}
				else if ( typeof(error) == 'string' )
				{
					sError = error;
				}
				else if ( typeof(error) == 'object' )
				{
					sError = JSON.stringify(error);
				}
				return <Alert variant='danger'>{sError}</Alert>;
			}
			return null;
		}
		else
		{
			return null;
		}
	}
}

export default ErrorComponent;
